import { IFAQ } from "components/FAQPinkAccordion/types";

export const faq: IFAQ[] = [{
  name: 'What subjects and ages does Tutor House cover?',
  text: ['We offer lessons in pretty much every subject on the school curriculum and more. Our lessons are offered to students from primary school to degree level. We specialise in online A-Level and GCSE tutoring as well as revision and retake courses. We also offer specific qualifications in subjects for IB, Pre-University (CIE) and Common Entrance.'],
},
{
  name: 'How much does a tutor cost?',
  text: ['All private tutors cost from £20 to £90 per hour — whether in-person or online. We aim to match you with a tutor that suits your budget and needs. There are no additional fees.'],
},
{
  name: 'Why should I get a private tutor?',
  text: [`We’ve seen time and time again that private tuition gives students better grades, subject-knowledge and even career opportunities. So now this option is fully available to you at a much more flexible rate, it’s silly not to make the most of it. Our students come from all walks of life — but all of them get exactly the same attention to improve their education.`],
},
{
  name: 'When can I start lessons?',
  text: [`As soon as you like! We can usually organise online tutoring to start within 24 hours! Once you’ve matched with your tutor and signed up, you’ll have 24/7 access to your tutor’s diary. So you can book lessons ASAP.`],
},
{
  name: 'How easy is it to learn online?',
  text: [`Online learning is very easy. Even if you’re not the most techy, don’t fret! We’ll give you a demo of the eWhiteboard and show you exactly how to use it. We have our own online whiteboard and interactive learning platform, which is free and simple to use.`],
},
{
  name: 'How many lessons will I need?',
  text: [`We recommend that students start with 20 or more lessons. Of course this depends on each individual’s needs. But our research shows that this is the best number of lessons to achieve learning goals and target grades. Read our industry report here to find out why.`],
},
{
  name: 'What’s included in the TH membership?',
  text: [`Our bulk-buy package includes One Lesson Free and unlimited access to the eWhiteboard features. This includes: recording sessions to playback later, a weekly report of your progress and other exclusive features. You’ll get access to free weekly resources: blogs, newsletters, past papers, exemplar essays and more! We’ll also keep you up to date on industry news and any upcoming events we’re hosting.`],
},
{
  name: 'How will I be charged for lessons?',
  text: [`We’ll ask for your card details when you register with Tutor House. As soon as you complete a lesson, you’ll be automatically charged. All payments are cashless for your convenience and you’ll receive a bill instantly to your email address. You can track all payments – and there are no extra fees!`],
},
{
  name: 'Can I change my tutor?',
  text: [`Absolutely! What’s important to us is that you’re getting the most out of your private tuition. So if you want to swap your tutor for someone else, no problem`],
},
{
  name: 'Do your tutors have a DBS check?',
  text: [`Mostly all of our tutors have a DBS check. It will say on the profile of the specific tutor if they’ve had their DBS check or not. We interview all tutors and all tutors have to go through training.`],
}];
